import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import _ from 'lodash';
import { Tenant } from '../models/tenant';
import { AuxiliarService } from './auxiliar.service';
import { TenantDrawerComponent } from '../components/drawers/tenant-drawer/tenant-drawer.component';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class TenantService {
  private tenantSubject = new BehaviorSubject({} as Tenant);
  public tenantObservable = this.tenantSubject.asObservable();

  constructor(
    private httpClient: HttpClient,
    private auxiliarService: AuxiliarService,
    private translate: TranslateService,
  ) { }

  // function to get selected tenant from header
  public getAppTenant(): Tenant {
    return this.tenantSubject.getValue();
  }

  // function to set selected tenant from header
  public setAppTenant(tenant: Tenant): void {
    this.tenantSubject.next(tenant);
  }
  
  // [GET] tenants
  public getTenants(): Observable<{ [index: string]: any; }> {
    const headers = new HttpHeaders({ 'X-Tenant': _.get(this.getAppTenant(), 'id') });
    return this.httpClient.get<HttpResponse<object>>
      (
        environment.api_server + environment.api_endpoints.tenants,
        { observe: 'response', headers }
      );
  }

  // [POST] create tenant
  public createTenant(tenant: Tenant): Observable<{ [index: string]: any; }> {
    const headers = new HttpHeaders({ 'X-Tenant': _.get(this.getAppTenant(), 'id') });
    return this.httpClient.post<HttpResponse<object>>
      (
        environment.api_server + environment.api_endpoints.tenants,
        tenant, { observe: 'response', headers }
      );
  }

  // [PATCH] update tenant
  public updateTenant(tenant: Tenant): Observable<{ [index: string]: any; }> {
    const headers = new HttpHeaders({ 'X-Tenant': tenant.id });
    return this.httpClient.patch<HttpResponse<object>>
      (
        environment.api_server + `${environment.api_endpoints.tenants}/${tenant.id}`,
        tenant, { observe: 'response', headers }
      );
  }

  // [DELETE] delete tenant
  public deleteTenant(tenant: Tenant): Observable<{ [index: string]: any; }> {
    const headers = new HttpHeaders({ 'X-Tenant': tenant.id });
    return this.httpClient.delete<HttpResponse<object>>(
      environment.api_server + `${environment.api_endpoints.tenants}/${tenant.id}`,
      { observe: 'response', headers }
    );
  }

  // open tenant detail
  public async openTenantDetail(tenant: Tenant | undefined, tenants: Tenant[], edit?: boolean): Promise<boolean> {
    const res = await this.auxiliarService.openDrawer(TenantDrawerComponent, {
      edit,
      tenant,
      tenants,
      position: 'right',
      iconRight: 'pi pi-building',
      titleRight: tenant ? this.translate.instant('button.edit-tenant') : this.translate.instant('button.new-tenant'),
      width: '700px'
    });
    return res;
  }
}
